
import { Link } from "react-router-dom";

export default function Discussion({ discussion }) {
	const maxLen = 50;
	const title = discussion.title.length > maxLen ? discussion.title.slice(0, maxLen) + "..." : discussion.title;

	return (
		<Link to={`/discussion_detail/${discussion.id}/`} className="no-underline h-full">
			<div className="flex flex-col bg-white rounded-[10px] p-[10px] h-full">
				<div className="font-Vazir-700 text-[16px] text-midGray">{title}</div>
				<div className="spacer p-[5px]"></div>
				<div className="flex flex-row items-center mt-auto">
					{discussion.profile_detail?.avatar_url && (
						<>
							<div className="w-[40px] aspect-square">
								<img
									src={discussion.profile_detail?.avatar_url}
									alt=""
									className="w-full h-full object-cover rounded-full"
								/>
							</div>
							<div className="spacer p-[5px]"></div>
						</>
					)}
					<div>
						<div className="font-Vazir-300 text-[14px] text-darkBlue">{discussion.profile_detail?.name}</div>
						<div className="spacer p-[2px]"></div>
						<div className="font-Vazir-300 text-[14px] text-darkBlue" dir="ltr">{discussion.j_create_date}</div>
					</div>
				</div>
			</div>
		</Link>
	)
}
